<template>
    <!-- 大运流年组件:查看 -->
    <div class="layout-comment-list">
        <div class="layout-clr-item" v-for="dayunData of pipanList" v-bind:key="dayunData.key" >
            <!-- 大运信息 -->
            <div class="layout-clr-dayun-info" v-if="dayunData && dayunData.data" v-bind:id="dayunData.key">
                <div class="layout-clr-title-box">
                    <span class="layout-clr-title" @click.stop="clickDayunTitle(dayunData)"><span class="layout-clr-title-title">{{dayunData.tMsg + ' ' + dayunData.gzMsg}}</span></span>
                    <span v-if="dayunData.data.content_type_all" :class="jxTypeClass(dayunData.data.content_type_all)">{{ JSON.parse(dayunData.data.content_type_all)[0] }}</span>
                </div>
                <div class="layout-clr-content" v-if="dayunData.data.content_type_pre">
                    <span class="layout-clr-label">前五年运势：</span>
                    <span :class="jxTypeClass(dayunData.data.content_type_pre)">{{ JSON.parse(dayunData.data.content_type_pre)[0] }}</span>
                </div>
                <div class="layout-clr-content" v-if="dayunData.data.content_type_last">
                    <span class="layout-clr-label">后五年运势：</span>
                    <span :class="jxTypeClass(dayunData.data.content_type_last)">{{ JSON.parse(dayunData.data.content_type_last)[0]}}</span>
                </div>
                <comment-content-read
                    v-if="dayunData.data.content != ''"
                    v-bind:className="'layout-clr-paragraph'"
                    v-bind:textId="dayunData.key"
                    v-bind:textValue="dayunData.data.content">
                </comment-content-read>
            </div>
            <!-- 流年 -->
            <div class="layout-clr-liunian-list" v-for="liunianData of dayunData.children" v-bind:key="liunianData.key" v-bind:id="'liunian'+liunianData.key+'_'+dayunData.key.slice(3)">
                <div class="layout-clr-liunian-item" v-if="liunianData && liunianData.data">
                    <div class="layout-clrln-title">
                        <span @click.stop="clickLiunianTitle(dayunData, liunianData)">
                            <span class="layout-clrln-title-title">{{liunianData.tMsg + ' ' + liunianData.gzMsg}}</span>
                        </span>
                        <span v-if="liunianData.data.content_type_all" :class="jxTypeClass(liunianData.data.content_type_all)">{{ JSON.parse(liunianData.data.content_type_all)[0] }}</span>
                    </div>
                    <div class="layout-clrln-content" v-if="liunianData.data.content_type_pre">
                        <span class="layout-clr-label">上半年运势：</span>
                        <span :class="jxTypeClass(liunianData.data.content_type_pre)">{{ JSON.parse(liunianData.data.content_type_pre)[0] }}</span>
                    </div>
                    <div class="layout-clrln-content" v-if="liunianData.data.content_type_last">
                        <span class="layout-clr-label">下半年运势：</span>
                        <span :class="jxTypeClass(liunianData.data.content_type_last)">{{ JSON.parse(liunianData.data.content_type_last)[0] }}</span>
                    </div>
                    <comment-content-read
                        v-if="liunianData.data.content != ''"
                        v-bind:className="'layout-clrln-paragraph'"
                        v-bind:textId="liunianData.key"
                        v-bind:textValue="liunianData.data.content">
                    </comment-content-read>
                    <div class="layout-clr-liunian-item layout-clr-liunian-item-inner" v-for="lyrsData in liunianData.children">
                        <div v-if="lyrsData.type == 'ls'" class="layout-clrln-title-two">
                            <p>
                                {{ lyrsData.tMsg }}
                                <span v-if="lyrsData.data.content_type_all" :class="jxTypeClass(lyrsData.data.content_type_all)">{{ JSON.parse(lyrsData.data.content_type_all)[0] }}</span>
                            </p>
                            <p>{{ lyrsData.gzMsg }}</p>
                        </div>
                        <div v-else class="layout-clrln-title-two">
                            <span class="layout-clrln-title-title">{{lyrsData.tMsg + ' ' + lyrsData.gzMsg}}</span>
                            <span v-if="lyrsData.data.content_type_all" :class="jxTypeClass(lyrsData.data.content_type_all)">{{ JSON.parse(lyrsData.data.content_type_all)[0] }}</span>
                        </div>
                        <comment-content-read
                            v-if="lyrsData.data.content != ''"
                            v-bind:className="'layout-clrln-paragraph'"
                            v-bind:textId="lyrsData.key"
                            v-bind:textValue="lyrsData.data.content">
                        </comment-content-read>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CommentContentRead from './CommentContentRead.vue'
import { COMMENT_DOM } from '../../modules/dom'
export default {
    name: 'CommentListRead',
    components: { CommentContentRead },
    computed: {
        pipanList() {
            return this.$store.state.comment.pipanInfoList;
        },
        pipanConfig() {
            return this.$store.state.comment.pipanConfig;
        },
        fromMyComment() {
            return this.$store.state.comment.fromMyComment;
        }
    },
    methods: {
        clickDayunTitle(dayunData) {
            this.$store.dispatch('minifatefortune/triggerFortuneItemClick', dayunData);
            setTimeout(() => {
                COMMENT_DOM.updateCommentFormReadScrollTop(dayunData.key);
            }, 100);
        },
        clickLiunianTitle(dayunData, liunianData) {
            this.$store.dispatch('minifatefortune/triggerFortuneItemClick', dayunData);
            setTimeout(() => {
                COMMENT_DOM.updateCommentFormReadScrollTop('liunian'+liunianData.key+'_'+dayunData.key.slice(3));
            }, 100);
        },
        jxTypeClass(type) {
            let typeText = type ? JSON.parse(type)[0] : '';
            if(typeText == '') { return '' };

            let typeList = this.pipanConfig.type ? this.pipanConfig.type.concat(['吉', '凶', '平', '吉藏凶', '凶藏吉']) : 
            ['好运', '差运', '平运', '吉中藏凶', '凶中藏吉', '吉', '凶', '平', '吉藏凶', '凶藏吉'];
            let result = '', resultIndex = typeList.indexOf(typeText);
            // '好运', '差运', '平运', '吉中藏凶', '凶中藏吉'
            
            switch(resultIndex%5) {
                case 0:
                    result = 'text-good'; break;
                case 1:
                    result = 'text-bad'; break;
                case 2:
                    result = 'text-ping'; break;
                case 3:
                    result = 'text-jix'; break;
                case 4:
                    result = 'text-xiongj'; break;
                default:
                    break;
            }
            return result;
        }

    }
}
</script>